// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules_dev/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".junk{visibility:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:0;display:none}", ""]);
// Exports
module.exports = exports;
